export enum WarehouseType {
    STANDARD = 'Standard',
    LVB = 'LVB'
}